import { createFileRoute, Outlet } from '@tanstack/react-router';

export const Route = createFileRoute('/profile/user')({
    component: () => <Outlet />,
});
